<template>
  <editor
    :init="initOptions"
    @input="updateText($event)"
    :initial-value="value"
  />
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

// Import TinyMCE
import 'tinymce/tinymce'
import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/code'
import 'tinymce/plugins/autoresize'

export default {
  components: {
    editor: Editor
  },
  data () {
    return {
      test: '',
      initOptions: {
        plugins: ['code', 'autoresize'],
        branding: false,
        autoresize_min_height: 350,
        autoresize_bottom_margin: 10,
        width: '100%',
        skin_url: '/tinymce/skins/ui/oxide',
        language: 'de',
        language_url: '/tinymce/langs/de.js'
      }
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    updateText (html) {
      this.$emit('input', html)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
